module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0590.050fb712.jpg";